// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "components-MainPage" + "." + "a0120565ef41f0aa1c8d" + ".css";
};